module.exports = __webpack_public_path__ + "img/LV40003960512.5489b0a3.png";